/**
 * AdOpt's Google landing-URL params — the client's mirror of
 * `ADOPT_GOOGLE_LANDING_PARAMS` / `ADOPT_GOOGLE_ADS_ID_PATTERN` /
 * `ADOPT_GCLID_PATTERN` in `@fias/db-types`
 * (packages/db-types/src/advertising-optimization.ts).
 *
 * Every AdOpt Google campaign appends `adopt_cid={campaignid}&adopt_crid={creative}`
 * to its landing URLs (the campaign's finalUrlSuffix), so the landing page knows
 * which campaign and ad drove the click even when the tracking ping was blocked.
 *
 * The client does not depend on `@fias/db-types`, so this is a copy, kept in
 * step by `tests/architecture/adopt-landing-params-client-parity.test.ts`.
 * This module imports nothing so that test can load it outside the client's
 * module graph.
 */

export const ADOPT_GOOGLE_LANDING_PARAMS = {
  campaignRef: 'adopt_cid',
  creativeRef: 'adopt_crid',
} as const;

/** A Google campaign / ad id: a positive integer of at most 20 digits. */
export const ADOPT_GOOGLE_ADS_ID_PATTERN = /^[1-9][0-9]{0,19}$/;

/**
 * A gclid the guest-trial mint will accept. A captured gclid that does not
 * match is not presented at mint (the server would 400 it).
 */
export const ADOPT_GCLID_PATTERN = /^[A-Za-z0-9._~-]{1,128}$/;
